/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import cookie from "react-cookies";
import axios from "axios";
import { checkClientAuth, CompanyID, checkingPermisson } from "../../Helpers/SettingHelper";
import { apiUrl, ecommerceapiUrl, clientheaderconfig } from "../../Helpers/Config";
import menuList from "./menu.json";
import { withRouter } from "../../../withRouter";
import { supabaseReservation, epicengageSupabase, epicengageSupabasev1 } from "../../../integrations/supabase/client";
import { supabaseEpicSocial } from "../../../integrations/supabase/EpicSocialClient";
class Header extends Component {
  constructor(props) {
    super(props);
    checkClientAuth(this.props);
    const companyPlans = cookie.load("companyPlans") ?? "";
    const totalOrder = cookie.load("totalOrder") ?? 0;
    this.state = {
      companyPlans: companyPlans,
      totalOrders: totalOrder,
      todayOrders: 0,
      featureOrders: 0,
      // Set initial state of song
      isPlaying: false,
      enableStatus: "",
    };
  }
  componentDidUpdate(prevProps) {
    // Check if route changed
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.stopPolling(); // Clear old interval
      this.startPolling(); // Start new interval
    }
  }
  componentWillUnmount() {
    this.stopPolling(); // Cleanup when header unmounts
  }
  startPolling = () => {
    this.interval = setInterval(() => {
      this.loadActivity();
    }, 10000);
  };
  stopPolling = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  };
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "/assets/js/main.js";
    script.async = true;
    document.body.appendChild(script);
    this.checking_Auth();
    this.startPolling();
    this.loadActivity();
    this.checkingEnableStatus();
    const companysupabaseReservationUserName = cookie.load("companysupabaseReservationUserName") || "";
    const companysupabaseReservationPassword = cookie.load("companysupabaseReservationPassword") || "";
    const companyEnableReservation = cookie.load("companyEnableReservation") || "false";

    if (companysupabaseReservationUserName !== "" && companysupabaseReservationPassword !== "" && companyEnableReservation === "true") {
      this.handleReservationLogin();
    }

    const companysupabaseEngageUserName = cookie.load("companysupabaseEngageUserName") || "";
    const companysupabaseEngagePassword = cookie.load("companysupabaseEngagePassword") || "";
    const companyEnableEpicEngage = cookie.load("companyEnableEpicEngage") || "false";

    if (companysupabaseEngageUserName !== "" && companysupabaseEngagePassword !== "" && companyEnableEpicEngage === "true") {
      this.handleEngageLogin();
    }

    const companysupabaseEngagev1UserName = cookie.load("companysupabaseEngagev1UserName") || "";
    const companysupabaseEngagev1Password = cookie.load("companysupabaseEngagev1Password") || "";
    const companyEnableEpicEngagev1 = cookie.load("companyEnableEpicEngagev1") || "false";
    if (companysupabaseEngagev1UserName !== "" && companysupabaseEngagev1Password !== "" && companyEnableEpicEngagev1 === "true") {
      this.handleEngageV1Login();
    }

    const companysupabaseEpicSocialUserName = cookie.load("companysupabaseEpicSocialUserName") || "";
    const companysupabaseEpicSocialPassword = cookie.load("companysupabaseEpicSocialPassword") || "";
    const companyEnableEpicSocial = cookie.load("companyEnableEpicSocial") || "false";
    if (companysupabaseEpicSocialUserName !== "" && companysupabaseEpicSocialPassword !== "" && companyEnableEpicSocial === "true") {
      this.handleEpicSocialLogin();
    }
  }
  checking_Auth() {
    axios.get(apiUrl + `client/checkingauth/${CompanyID()}`, clientheaderconfig).catch(() => {
      this.props.navigate("/logout");
    });
  }
  checkingEnableStatus() {
    axios
      .get(apiUrl + `client/checkingEnableStatus`, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ enableStatus: res.data.result });
        } else {
          this.setState({ enableStatus: "" });
        }
      })
      .catch(() => {});
  }
  playSound = () => {
    const audio = new Audio("/neworder.mp3");
    audio
      .play()
      .catch((e) => {
        console.warn("Audio play failed:", e);
      })
      .catch((e) => {});
  };
  loadActivity() {
    var urlShringTxt = `${ecommerceapiUrl}order/getactivity`;
    axios
      .get(urlShringTxt, {
        headers: {
          Authorization: `Bearer ${cookie.load("clientAccessToken")}`,
        },
      })
      .then((res) => {
        if (res.data.status === "ok") {
          const totalOrder_ = cookie.load("totalOrder") ?? 0;

          this.setState({ totalOrders: res.data.totalOrder, todayOrders: res.data.totalTodayOrder, featureOrders: res.data.totalFeatureOrder });
          if (parseInt(totalOrder_) !== res.data.totalOrder) {
            cookie.save("totalOrder", res.data.totalOrder, { path: "/" });
            this.playSound();
          }
        } else {
          this.setState({
            todayOrders: 0,
            featureOrders: 0,
            totalOrders: 0,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  gotoLink(link, submenuLength, e) {
    e.preventDefault();
    if (submenuLength === 0) {
      this.props.navigate(`/clientpanel/${link}`);
    }
  }

  handleReservationLogin = async () => {
    const companysupabaseReservationUserName_ = cookie.load("companysupabaseReservationUserName") || "";
    const companysupabaseReservationPassword_ = cookie.load("companysupabaseReservationPassword") || "";
    try {
      const { error } = await supabaseReservation.auth.signInWithPassword({
        email: companysupabaseReservationUserName_,
        password: companysupabaseReservationPassword_,
      });

      if (error) throw error;
      cookie.remove("companysupabaseReservationUserName", { path: "/" });
      cookie.remove("companysupabaseReservationPassword", { path: "/" });
    } catch (error) {
    } finally {
    }
  };

  handleEngageLogin = async () => {
    const companysupabaseEngageUserName_ = cookie.load("companysupabaseEngageUserName") || "";
    const companysupabaseEngagePassword_ = cookie.load("companysupabaseEngagePassword") || "";
    try {
      const { error } = await epicengageSupabase.auth.signInWithPassword({
        email: companysupabaseEngageUserName_,
        password: companysupabaseEngagePassword_,
      });

      if (error) throw error;
      cookie.remove("companysupabaseEngageUserName", { path: "/" });
      cookie.remove("companysupabaseEngagePassword", { path: "/" });
    } catch (error) {
    } finally {
    }
  };

  handleEngageV1Login = async () => {
    const companysupabaseEngagev1UserName_ = cookie.load("companysupabaseEngagev1UserName") || "";
    const companysupabaseEngagev1Password_ = cookie.load("companysupabaseEngagev1Password") || "";

    try {
      console.log(companysupabaseEngagev1UserName_, companysupabaseEngagev1Password_, "companyEnableEpicEngagev1");
      const { data, error } = await epicengageSupabasev1.auth.signInWithPassword({
        email: companysupabaseEngagev1UserName_,
        password: companysupabaseEngagev1Password_,
      });
      console.log(data, "datadatadatadata");
      if (error) throw error;
      cookie.remove("companysupabaseEngagev1UserName", { path: "/" });
      cookie.remove("companysupabaseEngagev1Password", { path: "/" });
    } catch (error) {
      console.log(error, "errorerrorerror");
    } finally {
    }
  };

  handleEpicSocialLogin = async () => {
    const companysupabaseEpicSocialUserName_ = cookie.load("companysupabaseEpicSocialUserName") || "";
    const companysupabaseEpicSocialPassword_ = cookie.load("companysupabaseEpicSocialPassword") || "";

    try {
      const { data, error } = await supabaseEpicSocial.auth.signInWithPassword({
        email: companysupabaseEpicSocialUserName_,
        password: companysupabaseEpicSocialPassword_,
      });
      console.log(data, "datadatadatadata");
      if (error) throw error;
      cookie.remove("companysupabaseEpicSocialUserName", { path: "/" });
      cookie.remove("companysupabaseEpicSocialPassword", { path: "/" });
    } catch (error) {
      console.log(error, "errorerrorerror");
    } finally {
    }
  };

  render() {
    var currentPage = this.props.currentPage;
    var enableEmailCampaign = cookie.load("enableEmailCampaign") ?? false;
    var enableSMSCampaign = cookie.load("enableSMSCampaign") ?? false;
    var companyEnableWhatsappCampaign = cookie.load("companyEnableWhatsappCampaign") ?? false;
    return (
      <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
        <div className="app-brand demo">
          <Link to={"/clientpanel/dashboard"} className="app-brand-link">
            <span className="app-brand-logo demo">
              <span>
                <img src={"/epicpay.png"} alt="EpicPay" />
              </span>
            </span>
          </Link>

          <a href={void 0} className="layout-menu-toggle menu-link text-large ms-auto">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.4854 4.88844C11.0081 4.41121 10.2344 4.41121 9.75715 4.88844L4.51028 10.1353C4.03297 10.6126 4.03297 11.3865 4.51028 11.8638L9.75715 17.1107C10.2344 17.5879 11.0081 17.5879 11.4854 17.1107C11.9626 16.6334 11.9626 15.8597 11.4854 15.3824L7.96672 11.8638C7.48942 11.3865 7.48942 10.6126 7.96672 10.1353L11.4854 6.61667C11.9626 6.13943 11.9626 5.36568 11.4854 4.88844Z"
                fill="currentColor"
                fillOpacity="0.6"
              />
              <path
                d="M15.8683 4.88844L10.6214 10.1353C10.1441 10.6126 10.1441 11.3865 10.6214 11.8638L15.8683 17.1107C16.3455 17.5879 17.1192 17.5879 17.5965 17.1107C18.0737 16.6334 18.0737 15.8597 17.5965 15.3824L14.0778 11.8638C13.6005 11.3865 13.6005 10.6126 14.0778 10.1353L17.5965 6.61667C18.0737 6.13943 18.0737 5.36568 17.5965 4.88844C17.1192 4.41121 16.3455 4.41121 15.8683 4.88844Z"
                fill="currentColor"
                fillOpacity="0.38"
              />
            </svg>
          </a>
        </div>

        <div className="menu-inner-shadow"></div>
        {console.log(window.innerHeight, window.innerHeight - 100, "innerHeightinnerHeight")}
        <ul className="menu-inner py-1 sidebar-menu my-scroll" /*  style={{height:`${parseInt(window.innerHeight)-100}px`}} */>
          {menuList.map((mitem, mindex) => {
            if (mitem.itemList.length > 0) {
              const itemkey = mitem.key;
              let allowToShowmenu = true;
              if (itemkey === "EpicPay" || itemkey === "Ecommerce") {
                if (this.state.companyPlans.indexOf(itemkey) < 0) {
                  allowToShowmenu = false;
                }
              }
              if (allowToShowmenu === true) {
                return (
                  <React.Fragment key={mindex}>
                    {mitem.title !== "" && (
                      <li className="menu-header fw-light mt-2">
                        <span className="menu-header-text">{mitem.title}</span>
                      </li>
                    )}
                    {mitem.itemList.map((item, index) => {
                      let showMenu = true;
                      if (item.key === "whatsapp") {
                        if (companyEnableWhatsappCampaign !== "true") {
                          showMenu = false;
                        }
                      } else if (item.key === "campaign") {
                        if (enableEmailCampaign !== "true" && enableSMSCampaign !== "true") {
                          showMenu = false;
                        }
                      } else if (["report", "commission", "holiday", "dashboard"].indexOf(item.key) >= 0) {
                        if (this.state.companyPlans.indexOf("EpicPay") < 0) {
                          showMenu = false;
                        }
                      } else if (["ecomdashboard"].indexOf(item.key) >= 0) {
                        if (this.state.companyPlans.indexOf("Ecommerce") < 0) {
                          showMenu = false;
                        }
                      } else if (["reservation"].indexOf(item.key) >= 0) {
                        if (this.state.enableStatus?.companyEnableReservation !== true) {
                          showMenu = false;
                        }
                      } else if (["catering"].indexOf(item.key) >= 0) {
                        if (this.state.enableStatus?.companyEnableCatering !== true) {
                          showMenu = false;
                        }
                      } else if (["enagev1"].indexOf(item.key) >= 0) {
                        if (this.state.enableStatus?.companyEnableEpicEngagev1 !== true) {
                          showMenu = false;
                        }
                      } else if (["enage"].indexOf(item.key) >= 0) {
                        if (this.state.enableStatus?.companyEnableEpicEngagev1 === true) {
                          showMenu = false;
                        } else if (this.state.enableStatus?.companyEnableEpicEngage !== true) {
                          showMenu = false;
                        }
                      } else if (["spinwheel"].indexOf(item.key) >= 0) {
                        if (this.state.enableStatus?.companyEnableSpinWheel !== true) {
                          showMenu = false;
                        }
                      } else if (["scratch"].indexOf(item.key) >= 0) {
                        if (this.state.enableStatus?.companyEnableScratch !== true) {
                          showMenu = false;
                        }
                      } else if (["EpicSocial", 'epicSocial'].indexOf(item.key) >= 0) {
                        if (this.state.enableStatus?.companyEnableEpicSocial !== true) {
                          showMenu = false;
                        }
                      }      
                          

                      if (checkingPermisson(item.moduleList, "view") && showMenu === true) {
                        return (
                          <li className={`menu-item ${item.activeList.indexOf(currentPage) >= 0 ? (item.subMenu.length > 0 ? "open" : "active") : ""}`} key={index}>
                            <a
                              href={`/clientpanel/${item.link}`}
                              className={`menu-link ${item.subMenu.length > 0 && "menu-toggle"}`}
                              onClick={this.gotoLink.bind(this, item.link, item.subMenu.length)}
                            >
                              <i className={`menu-icon tf-icons ${item.icon.indexOf("mdi") >= 0 ? "mdi" : ""} ${item.icon}`}></i>
                              <div>{item.title}</div>
                              {item.key === "orders" && this.state.totalOrders > 0 && <div className="badge bg-primary rounded-pill ms-auto">{this.state.totalOrders}</div>}
                            </a>
                            {item.subMenu.length > 0 && (
                              <ul className="menu-sub">
                                {item.subMenu.map((subItem, subIndex) => {
                                  let showSubMenu = true;
                                  if (subItem.key === "emailBuilder" || subItem.key === "emailcampaign") {
                                    if (enableEmailCampaign !== "true") {
                                      showSubMenu = false;
                                    }
                                  } else if (subItem.key === "smscampaign") {
                                    if (enableSMSCampaign !== "true") {
                                      showSubMenu = false;
                                    }
                                  } else if (["outlet-tag", "zone", "timeslot"].indexOf(subItem.key) >= 0) {
                                    if (this.state.companyPlans.indexOf("Ecommerce") < 0) {
                                      showSubMenu = false;
                                    }
                                  } else if (["referral", "points", "customeranalytics", "analyticsgroup"].indexOf(subItem.key) >= 0) {
                                    if (this.state.companyPlans.indexOf("EpicPay") < 0) {
                                      showSubMenu = false;
                                    }
                                  } else if (["catering-orders"].indexOf(subItem.key) >= 0) {
                                    if (this.state.enableStatus?.companyEnableCatering !== true) {
                                      showSubMenu = false;
                                    }
                                  } else if (["spinwheel"].indexOf(subItem.key) >= 0) {
                                    const companyEnableSpinWheel = cookie.load("companyEnableSpinWheel") ?? "false";
                                    if (companyEnableSpinWheel === "false") {
                                      showSubMenu = false;
                                    }
                                  }

                                  if (checkingPermisson(subItem.moduleList, "view") && showSubMenu === true) {
                                    return (
                                      <li className={`menu-item ${subItem.activeList.indexOf(currentPage) >= 0 ? "active" : ""}`} key={subIndex}>
                                        <Link to={`/clientpanel/${subItem.link}`} className="menu-link">
                                          <div>{subItem.title}</div>
                                          {subItem.key === "today-order" && this.state.todayOrders > 0 && <div className="badge bg-primary rounded-pill ms-auto">{this.state.todayOrders}</div>}
                                          {subItem.key === "feature-order" && this.state.featureOrders > 0 && <div className="badge bg-primary rounded-pill ms-auto">{this.state.featureOrders}</div>}
                                        </Link>
                                      </li>
                                    );
                                  } else {
                                    return "";
                                  }
                                })}
                              </ul>
                            )}
                          </li>
                        );
                      } else {
                        return "";
                      }
                    })}
                  </React.Fragment>
                );
              } else {
                return "";
              }
            }
          })}
        </ul>
      </aside>
    );
  }
}

export default withRouter(Header);
